import React, { Component } from 'react'

import PaystackButton from 'react-paystack'

const PUBLIC_KEY= "pk_test_3b618f2ab4eda42dc65da2546c85163307e12bfe"
export default class Paystack extends Component {
  constructor(props){
    super(props)
  }

  render () {
    return (
      <div>
        <PaystackButton 
          text={this.props.text}
          callback={this.props.callback}
          close={this.props.close}
          reference={this.props.reference}
          email={this.props.email}
          amount={this.props.amount}
          paystackkey={PUBLIC_KEY}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Payments.js